import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'sp-payouts-export-message',
    templateUrl: './payouts-export-message.component.html',
    styleUrls: ['./payouts-export-message.component.scss'],
})
export class PayoutsExportMessageComponent implements OnInit {
    success = true;
    constructor(
        public dialogRef: MatDialogRef<PayoutsExportMessageComponent>,
        //@Optional() is used to prevent error if no data is passed
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        this.success = this.data.success;
    }

    close() {
        this.dialogRef.close();
    }
}
